// Per-region branding, baked in at build time from .env.<region>.
// See DEPLOY.md "Adding a new region".
export const APP_TITLE = process.env.NEXT_PUBLIC_APP_TITLE!;
// Used only for <meta description>/OG tags, which render once at build time
// and can't react to the client-side locale switcher — visible page text
// uses EVENT_DATE/EVENT_ADDRESS below through t("eventDetails") instead, so
// it's translated per the selected locale.
export const APP_DESCRIPTION = process.env.NEXT_PUBLIC_APP_DESCRIPTION!;
export const APP_LOGO = process.env.NEXT_PUBLIC_APP_LOGO!;
export const EVENT_DATE = process.env.NEXT_PUBLIC_EVENT_DATE!;
export const EVENT_ADDRESS = process.env.NEXT_PUBLIC_EVENT_ADDRESS!;

// The event's own name, shown as the heading on every screen. Optional: a region
// that leaves it unset keeps the translated t("electionTitle"), which is the
// Territorial Community Italy wording. A region that sets it (Emanuel Roma) gets
// its own name instead — untranslated, because it is a proper noun. Without this
// every region wore Brescia's name.
const ELECTION_TITLE = process.env.NEXT_PUBLIC_ELECTION_TITLE ?? "";

export function electionTitle(t: (key: string) => string): string {
  return ELECTION_TITLE || t("electionTitle");
}

// True when this region has event details worth printing. Both empty renders
// "Event date: · Event address:" — dangling labels with nothing after them.
export const HAS_EVENT_DETAILS = Boolean(EVENT_DATE || EVENT_ADDRESS);
